import { lazy } from "react";
import { Route, Navigate } from "react-router-dom";

export enum PlatformRoutes {
    PROJECTS = "/projects",
    OWNER = "/owner",
    INVESTOR = "/investor",
    PROJECT_PROPERTY = "/project-property/:id",
    PROPERTY_TYPE = "/property-type/:id",
    PROPERTY_TYPE_IMAGES = "/property-type/:id/images",
    PROPERTIES = "/properties",
    PROJECT_INVESTOR = "/project-investor/:id",
    CONTRACTS = "/contracts",
    HOME_PAGE_DRAFT = "/home-page-draft",
    MARKETPLACE = "/propiedades",
    MARKETPLACE_DETAIL = "/propiedades/:id",
}

const ProjectProperty = lazy(() => import("./ProjectProperty"));
const PropertyType = lazy(() => import("./PropertyType"));
const PropertyTypeImages = lazy(() => import("./PropertyTypeImages"));
const Projects = lazy(() => import("./Projects"));
const Properties = lazy(() => import("./Properties"));
const Contracts = lazy(() => import("./Contracts"));
const ProjectPageLayoutDraft = lazy(() => import("./ProjectPageLayoutDraft"));
const MarketplaceListPage = lazy(() => import("module/marketplace/page/MarketplaceListPage"));
const PropertyDetailPage = lazy(() => import("module/marketplace/page/PropertyDetailPage"));

export const PlatformRouter = (
    <>
        <Route path="/" element={<Projects type={"investment"} />} />
        <Route path={PlatformRoutes.PROJECTS} element={<Projects type={"investment"} />} />
        <Route path={PlatformRoutes.OWNER} element={<Projects type={"property"} />} />
        <Route path={PlatformRoutes.INVESTOR} element={<Navigate to="/" replace />} />
        <Route path={PlatformRoutes.PROJECT_PROPERTY} element={<ProjectProperty type={"property"} />} />
        <Route path={PlatformRoutes.PROPERTY_TYPE_IMAGES} element={<PropertyTypeImages />} />
        <Route path={PlatformRoutes.PROPERTY_TYPE} element={<PropertyType />} />
        <Route path={PlatformRoutes.PROPERTIES} element={<Properties type={"property"} />} />
        <Route path={PlatformRoutes.PROJECT_INVESTOR} element={<ProjectProperty type={"investment"} />} />
        <Route path={PlatformRoutes.CONTRACTS} element={<Contracts />} />
        <Route path={PlatformRoutes.HOME_PAGE_DRAFT} element={<ProjectPageLayoutDraft />} />
        <Route path={PlatformRoutes.MARKETPLACE} element={<MarketplaceListPage />} />
        <Route path={PlatformRoutes.MARKETPLACE_DETAIL} element={<PropertyDetailPage />} />
    </>
);
